export const environment = {
    production: false,
    baseURL: 'https://dev-dashboard.orglensglobal.com/api/v1/', // Backend URL for development
    oldBaseURL: 'https://orglens.org/api/v1/',
      old_dashboardURL: 'https://orglens.org',
    dashboardURL: 'https://dev-dashboard.orglensglobal.com',
    auth_enabled: false
  };